import CardChargeApiModel from './card-charge.api-model';
import type ICardCharges from '../../../models/tap-and-go/card-charges.model';

export default class CardChargesApiModel {
  public totalCount!: number;
  public unfilteredCount!: number;
  public charges!: CardChargeApiModel[];
  public static mapToBusinessModel(apiModel: CardChargesApiModel): ICardCharges {
    return {
      charges: apiModel.charges.map(CardChargeApiModel.mapToBusinessModel),
      totalCount: apiModel.totalCount,
      unfilteredCount: apiModel.unfilteredCount,
    };
  }
}
